export const TRANSLATIONS_JP_SETTINGS_GOOGLE = {
  "settings.google.connection_status_title": "接続状態",
  "settings.google.loading_status": "状態を読み込み中...",
  "settings.google.connected": "接続済み",
  "settings.google.connect_button": "Google に接続",
  "settings.google.no_accounts": "接続されたアカウントはありません。",
  "settings.google.gmail_messages_title": "Gmail メッセージ",
  "settings.google.no_messages": "表示するメッセージがありません。",
  "settings.google.drive_files_title": "Drive ファイル",
  "settings.google.root": "（ルート）",
  "settings.google.no_files": "表示するファイルがありません。",
  "settings.google.diagnostics_title": "診断とテスト",
  "settings.google.audit_title": "監査とセキュリティ",
  "settings.google.manage_access_link": "Google アカウントでアクセスを管理",
  "settings.google.privacy_policy": "プライバシーポリシー",
  "settings.google.terms_of_service": "利用規約",
  "settings.google.multi_account_title": "複数アカウント管理",
  "settings.google.reauthorize": "再認可",
  "settings.google.revoke": "取り消す",
  "settings.google.make_default": "既定にする",
  "settings.google.oauth_processing": "Google 認証を処理中...",
  "settings.google.table.subject": "件名",
  "settings.google.table.from": "差出人",
  "settings.google.table.received_at": "受信日時",
  "settings.google.table.body_preview": "プレビュー",
  "settings.google.table.has_attachments": "添付ファイル",
  "settings.google.table.name": "名前",
  "settings.google.table.type": "種類",
  "settings.google.table.size": "サイズ",
  "settings.google.table.modified": "更新日",
  "settings.google.table.created_by": "作成者",
  "settings.google.table.status": "ステータス",
  "settings.google.table.time": "時刻",
  "settings.google.table.message": "メッセージ",
  "settings.google.table.account": "アカウント",
  "settings.google.table.scopes": "スコープ",
  "settings.google.table.default": "既定",
  "settings.google.table.actions": "操作",
  "settings.google.table.sync_period": "同期開始日",
  "settings.google.save_sync_start_date": "日付を保存",
  'settings.google.sync_process_title': 'アカウント同期',
  'settings.google.sync.mail_sync_status': 'メール同期ステータス',
  'settings.google.sync.drive_sync_status': 'ドライブ同期ステータス',
  'settings.google.sync.last_read_email_date': '最後に同期したメールの日付',
  'settings.google.sync.last_sync_date': '最終同期日',
  'settings.google.sync.emails_processed': '処理済みメール数',
  'settings.google.sync.period': '同期期間',
  'settings.google.sync.period_updated_prefix': '同期開始日が次に更新されました',
  'settings.google.sync.resync_requested': '再同期が要求されました。',
  'settings.google.sync.set_period': '期間を設定',
  'settings.google.sync.all': 'すべて',
  'settings.google.sync.not_set': '未設定',
};
